import React from "react";
// Common components
import {
  FullScreenLoading,
  Form,
  Button,
  TimePicker,
  TextInput,
} from "src/Components";
// Requests
import { getConfig, setConfig } from "src/Requests/connections";
// Utilities
import moment from "moment";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { toast } from "react-toastify";

interface Props {
  onClose: () => void;
}
const SettingsModal: React.FC<Props> = (props) => {
  // states
  const [formValues, setFormValues] = React.useState({
    startTime: "12:00:00",
    endTime: "12:00:00",
    commodityStartTime: "12:00:00",
    commodityEndTime: "12:00:00",
  });
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    getConfig()
      .then((r) => {
        setFormValues({
          startTime: r.startTime,
          endTime: r.endTime,
          commodityStartTime: r.commodityStartTime,
          commodityEndTime: r.commodityEndTime,
        });
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const timePickerChangeHandler = (
    name: string,
    value: {
      timeString: string;
      ISOString: string | null;
    },
  ) => {
    setFormValues({ ...formValues, [name]: value.timeString });
  };

  const clickHandler = () => {
    setLoading(true);
    setConfig(formValues)
      .then((r) => {
        if (r.data) {
          toast.success(r.msg);
          props.onClose();
        } else {
          toast.error(r.msg);
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };
  return (
    <div className="flex flex-col items-center gap-4">
      تنظیمات اتصال اتوماتیک
      <Form className=" gap-3 p-2 px-2 !mx-auto">
        <div
          className="grid grid-cols-3 gap-2"
          style={{
            gridTemplateColumns: "50px 1fr 1fr",
          }}
        >
          <div />
          <div className="text-[10px] whitespace-nowrap text-center">
            ساعت شروع
          </div>
          <div className="text-[10px] whitespace-nowrap text-center">
            ساعت پایان
          </div>
          <div className="text-[10px] whitespace-nowrap w-auto">
            اوراق بهادار
          </div>

          <TimePicker
            name="startTime"
            value={
              moment().format("YYYY-MM-DD") +
              "T" +
              (formValues.startTime || "12:00:00")
            }
            onChange={timePickerChangeHandler}
            placeholder="از ساعت"
          />

          <TimePicker
            name="endTime"
            value={
              moment().format("YYYY-MM-DD") +
              "T" +
              (formValues.endTime || "12:00:00")
            }
            onChange={timePickerChangeHandler}
            placeholder="از ساعت"
          />
          <div className="text-[10px] whitespace-nowrap w-auto">بورس کالا</div>
          <TimePicker
            name="commodityStartTime"
            value={
              moment().format("YYYY-MM-DD") +
              "T" +
              (formValues.commodityStartTime || "12:00:00")
            }
            onChange={timePickerChangeHandler}
            placeholder="از ساعت"
          />

          <TimePicker
            name="commodityEndTime"
            value={
              moment().format("YYYY-MM-DD") +
              "T" +
              (formValues.commodityEndTime || "12:00:00")
            }
            onChange={timePickerChangeHandler}
            placeholder="از ساعت"
          />
        </div>
      </Form>
      <div className="w-min">
        <Button
          text="ثبت"
          onClick={clickHandler}
          variant="contained"
          loading={loading}
        />
      </div>
    </div>
  );
};

export default SettingsModal;
